export const SELECTOR_FORMAT_ERROR = '请使用 #id 绑定试戴元素，并确保元素中已有用户图片文件';
export const HTML_ELEMENT_NOT_FOUND = '找不到试戴容器 HTML 元素';
export const ADJUST_TYPE_ERROR = '调整参数需要为对象';
export const IMAGE_COMPRESS_FAILED = '用户图片压缩处理失败';
